var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqBrakes = function SvgFaqBrakes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-brakes_svg__a)",
    d: "M14.052.598a1.3 1.3 0 0 0-.628-.223 2.3 2.3 0 0 0-.606.042c-.83.107-1.65.277-2.448.532a14.5 14.5 0 0 0-2.267.937 13.6 13.6 0 0 0-2 1.277 13.6 13.6 0 0 0-1.778 1.628 14.4 14.4 0 0 0-1.479 1.916 15 15 0 0 0-1.128 2.15 13.4 13.4 0 0 0-.947 3.586c-.021.202-.064.415-.064.628 0 .223.053.447.16.638.212.405.628.65 1.064.703.128.01.255 0 .383 0H3.9c.35 0 .713.01 1.064 0a1.4 1.4 0 0 0 1.117-.65c.128-.202.17-.415.192-.649v-.117c0-.053.021-.106.021-.16.021-.106.032-.202.053-.308.085-.404.192-.798.33-1.181.032-.096.075-.192.107-.288 0-.02.02-.042.02-.063 0 0 .012-.032.022-.043.021-.043.043-.085.053-.128.086-.18.17-.372.266-.542q.288-.527.639-1.022a1 1 0 0 1 .085-.107c.01-.02.021-.031.043-.053 0 0 .032-.042.042-.053.064-.074.128-.16.192-.234.128-.15.266-.298.404-.436.139-.15.288-.288.437-.415l.223-.192c.032-.032.074-.064.106-.096.022-.01.032-.032.054-.042 0 0 .02-.011.032-.022 0 0 .02-.01.02-.02h.011s.022-.012.032-.022c.022-.01.032-.032.054-.043l.127-.096q.127-.093.256-.17c.17-.106.34-.213.51-.308.17-.096.352-.192.533-.277l.287-.128s.032-.01.042-.021h.022c.01 0 .021 0 .032-.01.053-.022.095-.043.149-.054a9 9 0 0 1 1.17-.362c.203-.042.405-.085.607-.117.021 0 .053 0 .074-.01h.064c.032 0 .053 0 .085-.011.032 0 .054 0 .086-.01a1.3 1.3 0 0 0 .319-.118c.404-.202.67-.617.723-1.064.022-.128.011-.266.011-.394V1.77c0-.458-.223-.873-.607-1.128z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-brakes_svg__b)",
    fillRule: "evenodd",
    d: "M18.01 3.067a13 13 0 0 0-1.83-.128v1.597c.543 0 1.075.042 1.607.117 5.64.787 9.897 5.682 9.897 11.397 0 6.343-5.161 11.504-11.504 11.504a11.485 11.485 0 0 1-11.323-9.45l-.053-.32a12 12 0 0 1-.128-1.744H3.08c0 .66.053 1.33.149 1.979l.064.362C4.42 24.617 9.848 29.14 16.19 29.14c7.226 0 13.1-5.875 13.1-13.1 0-6.503-4.842-12.08-11.27-12.984z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-brakes_svg__c)",
    fillRule: "evenodd",
    d: "M15.287 23.404a1.05 1.05 0 0 0 1.054 1.053 1.05 1.05 0 0 0 1.053-1.053 1.05 1.05 0 0 0-1.053-1.054 1.05 1.05 0 0 0-1.054 1.054",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-brakes_svg__d)",
    fillRule: "evenodd",
    d: "M24.97 16.167a1.05 1.05 0 0 0-1.053-1.054 1.05 1.05 0 0 0-1.054 1.054 1.05 1.05 0 0 0 1.054 1.054 1.05 1.05 0 0 0 1.053-1.054",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-brakes_svg__e)",
    fillRule: "evenodd",
    d: "M16.34 20.553c2.405 0 4.363-1.948 4.363-4.364s-1.947-4.363-4.363-4.363-4.363 1.948-4.363 4.363 1.947 4.364 4.363 4.364m0-6.97c1.447 0 2.618 1.17 2.618 2.617s-1.17 2.618-2.618 2.618-2.618-1.17-2.618-2.618a2.616 2.616 0 0 1 2.618-2.618",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-brakes_svg__f)",
    fillRule: "evenodd",
    d: "M8.444 17.22a1.05 1.05 0 0 0 1.054-1.053c0-.585-.468-1.054-1.054-1.054s-1.053.469-1.053 1.054a1.05 1.05 0 0 0 1.053 1.054",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-brakes_svg__g)",
    fillRule: "evenodd",
    d: "M16.34 9.74c.586 0 1.054-.468 1.054-1.054s-.468-1.053-1.053-1.053c-.586 0-1.054.468-1.054 1.053s.468 1.054 1.054 1.054",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-brakes_svg__a",
    x1: 7.663,
    x2: 7.663,
    y1: 14.416,
    y2: 0.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-brakes_svg__b",
    x1: 16.186,
    x2: 16.186,
    y1: 29.14,
    y2: 2.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-brakes_svg__c",
    x1: 16.341,
    x2: 16.341,
    y1: 24.457,
    y2: 22.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-brakes_svg__d",
    x1: 23.917,
    x2: 23.917,
    y1: 17.221,
    y2: 15.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-brakes_svg__e",
    x1: 16.34,
    x2: 16.34,
    y1: 20.553,
    y2: 11.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-brakes_svg__f",
    x1: 8.444,
    x2: 8.444,
    y1: 17.221,
    y2: 15.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-brakes_svg__g",
    x1: 16.341,
    x2: 16.341,
    y1: 9.74,
    y2: 7.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgFaqBrakes;